import { monitoringAccoladesData, title } from './data'

export const useMonitoringPageAccoladesData = () => {
  return {
    title,
    monitoringAccoladesData
  }
}
